import { datadogRum } from "@datadog/browser-rum";

const env = process.env.NODE_ENV === "production" ? "prod" : process.env.NODE_ENV === "staging" ? "stg" : "dev";

datadogRum.init({
  applicationId: "6f760f5a-de82-485c-a286-9da6bac5c567",
  clientToken: "pubc9636512f65a3adfec63fa394f14eb50",
  site: "datadoghq.eu",
  env,
  version: process.env.CI_COMMIT_SHA ? process.env.CI_COMMIT_SHA : "unknown",
  service: "plabu-phx-marketplace-user-service",
  sessionSampleRate: env === "prod" ? 100 : 0,
  sessionReplaySampleRate: env === "prod" ? 100 : 0,
  trackSessionAcrossSubdomains: true,
  useSecureSessionCookie: true,
  useCrossSiteSessionCookie: true,
  allowFallbackToLocalStorage: true,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "allow",
});
